import pinia from '@/stores'
import { useSnackbarStore } from '@/stores/snackbar'

const snackbar = {
  show (data) {
    useSnackbarStore(pinia).showMessage(data)
  },
  hide (data) {
    useSnackbarStore(pinia).hideMessage()
  },
}

export default snackbar
